import React, {Component} from 'react';
import {Button, Table} from "antd";
import {api, app} from "../../app";
import utils from "../../utils";

class OpeningInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            subject_id:'',//附近班级id
            total: 0,
            page: 1,
        }
    }

    componentDidMount() {
        this._isMounted = true;
        this.nearTheClass()
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    handleCloseOpeningModal = (id,obj) => {
        this.props.onClose({subject_id:id,opening_data:obj});
    }

    /**
     * 附近班列表
     **/
    nearTheClass = async (page = 1) => {
        await this.setData({ page, data_loading: true })
        let { region_id } = this.props, params = {
            page,
            apply_province_id:region_id
        }
        let { flag, data, msg, total } = await app.post(api.SkillTrainTransferList, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        await this.setData({ dataList: utils.addArrayKey(data), data_loading: false, total: Number(total || 0) })
    }
    /**
     * 设置值
     * @param data
     */
    setData = (data) => app.setStateSync(this, data)

    render() {
        let {page, total} = this.state,
            columns = [
            {
                title: '期望开班城市',
                dataIndex: 'province_name',
                key: 'province_name',
                render (province, record) {
                    return province + record.city_name
                }
            },
            {
                title: '培训课程',
                dataIndex: 'train_name',
                key: 'train_name'
            },
            {
                title: '培训科目',
                dataIndex: 'names',
                key: 'names'
            },
            {
                title: '预报名费(元)',
                dataIndex: 'beforehand_money',
                key: 'beforehand_money'
            },
            {
                title: '报名状态',
                dataIndex: 'status_name',
                key: 'status_name'
            },
            {
                title: '操作',
                dataIndex: 'subject_id',
                key: 'subject_id',
                render: (id,obj) => {
                    return (
                        <span>
                            {obj.status === '1'?
                                <Button onClick={() => this.handleCloseOpeningModal(id,obj)} type="primary" size="large">我要报名</Button>
                            :null}
                        </span>
                    )
                }
            }
        ], dataList = this.state.dataList, data_loading = this.state.data_loding
        return(
            <div className="opening-info">
                <Table size="small"
                    locale={app.tbLocale(data_loading)}
                    columns={columns}
                    dataSource={dataList}
                    loading={data_loading}
                    pagination={{
                       current: page,
                       total,
                       pageSize: 20,
                       showTotal: (t) => `总数量：${t}`,
                       onChange: this.nearTheClass
                    }}
                >
                </Table>
            </div>
        )
    }
}
export default OpeningInfo;



// WEBPACK FOOTER //
// ./src/routes/skillTrain/OpeningInfo.jsx